import React from 'react';
import type { EmptyStateProps } from './types/UIProps';

export type { EmptyStateProps };

export function EmptyState({
  title,
  description,
  action,
  className = '',
}: EmptyStateProps): React.ReactElement {
  return (
    <div
      className={`flex flex-col items-center justify-center gap-2 rounded-xl border border-dashed border-gray-200 bg-gray-50/80 px-6 py-10 text-center dark:border-slate-700 dark:bg-slate-900 ${className}`.trim()}
    >
      <p className="text-sm font-semibold text-gray-800 dark:text-slate-200">{title}</p>
      {description ? (
        <p className="max-w-md text-xs text-gray-500 dark:text-slate-400">{description}</p>
      ) : null}
      {action ? <div className="mt-2">{action}</div> : null}
    </div>
  );
}
